import React, { useEffect, useRef, useState } from 'react';

const VideoComponent = ({ video, autoPlayWidth = 10000, children }) => {
    const videoRef = useRef(null);
    const [windowSize, setWindowSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight
    });

    useEffect(() => {
        const handleResize = () => {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight
            });
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if (videoRef.current && windowSize.width < autoPlayWidth) {
            videoRef.current.play().catch(error => {
                console.error('Error attempting to play video:', error);
            });
        }
    }, [windowSize, autoPlayWidth]);

    if (windowSize.width < autoPlayWidth)
        return (
            <div>
            {/* <div className='bg-white dark:bg-gray-950 w-[300px] h-[400px] lg:w-[450px] lg:h-[350px] rounded-xl shadow-md hover:shadow-2xl transition-all ease-in-out duration-400'> */}
                <video
                    ref={videoRef}
                    autoPlay
                    loop
                    muted
                    playsInline
                    className="w-full h-full"
                >
                    <source src={video} type="video/mp4" />
                </video>

                {children &&
                    <div className="absolute top-0 left-0 w-full h-full dark:bg-gray-900 bg-white opacity-0 hover:opacity-60 rounded-lg transition-all ease-in-out duration-300 z-10 ">
                        <div className="relative top-1/3 text-center align-middle font-bold text-xl text-black">
                            {children}
                        </div>
                    </div>

                }
            </div>
        );
};

export default VideoComponent;
